/** Poll until a tour target is visible (not display:none / zero-size). */

function isTourTargetVisible(el: Element | null): boolean {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  if (rect.width < 2 || rect.height < 2) return false;
  const style = window.getComputedStyle(el);
  if (style.display === "none" || style.visibility === "hidden") return false;
  if (Number(style.opacity) === 0) return false;
  return true;
}

export async function waitForTourTarget(
  selector: string,
  timeoutMs = 5000
): Promise<boolean> {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const el = document.querySelector(selector);
    if (isTourTargetVisible(el)) {
      await new Promise((r) => setTimeout(r, 120));
      return true;
    }
    await new Promise((r) => setTimeout(r, 80));
  }
  return false;
}

/** First matching selector that becomes visible wins. */
export async function waitForAnyTourTarget(
  selectors: string[],
  timeoutMs = 5000
): Promise<boolean> {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    for (const selector of selectors) {
      if (isTourTargetVisible(document.querySelector(selector))) {
        await new Promise((r) => setTimeout(r, 120));
        return true;
      }
    }
    await new Promise((r) => setTimeout(r, 80));
  }
  return false;
}

export function parseTargetSelectors(target: string): string[] {
  return target.split(",").map((s) => s.trim()).filter(Boolean);
}
